"use strict";
var $ = require("jquery");
var ko = require("knockout");
var toastr = require("toastr");
var BaseViewModel = (function () {
    function BaseViewModel(options) {
        this.successMessage = ko.observable();
        this.errorMessages = ko.observableArray();
        this.options = options;
        if (options) {
            if (options.successMessage) {
                toastr.success(options.successMessage);
            }
            if (options.errorMessage) {
                toastr.error(options.errorMessage);
            }
        }
    }
    BaseViewModel.prototype.fullReloadPage = function () {
        window.location.reload(true);
    };
    BaseViewModel.prototype.reloadPage = function (fragment) {
        if (fragment) {
            $.pjax.reload(fragment, { fragment: fragment });
        }
        else {
            $.pjax.reload("#pjax-container");
        }
    };
    BaseViewModel.prototype.redirectToPage = function (url, container) {
        if (container === void 0) { container = "#pjax-container"; }
        $.pjax({ url: url, container: container });
    };
    BaseViewModel.prototype.forceRedirectToPage = function (url) {
        window.location = url;
    };
    BaseViewModel.prototype.showModal = function (options) {
        var component = window["AppComponents"].ModalDialog;
        this.modal = component;
        this.modal.show(options);
    };
    return BaseViewModel;
}());
exports.BaseViewModel = BaseViewModel;
//# sourceMappingURL=baseViewModel.js.map